module.exports = __webpack_public_path__ + "static/media/icn-lock-white.5e726480.svg";